import { ActivityLog } from 'src/interfaces/common/IdValue';
import { PaginationAndFilter } from 'src/interfaces/common/pagination';
import { BankDetails, BasicProfile, BrandsProducts, ChannelPartner, DocumentDetails, FileModel, DayAreas, ServiceType } from 'src/interfaces/new-channel-partner/channelPartner';
import { Availability } from 'src/interfaces/new-technician/technician';
import axiosClient from 'src/utils/axios-client';
import { APIConfig } from '../../config';

class ChannelPartnerApi {
  private channelPartnerApiUrl = APIConfig.channelPartnerApiUrl;

  private requestManagementUrl = APIConfig.requestManagementUrl;

  async addNewChannelPartner(attributes: BasicProfile):
  Promise<{ responseData: any, statusCode: number }> {
    try {
      const res = await axiosClient.post(`${this.channelPartnerApiUrl}channel-partner`, attributes)
        .then((response) => response);

      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response?.data || error.message || 'Network error',
        statusCode: error.response?.status || 500
      });
    }
  }

  async getChannelPartnerProfile():
  Promise<{ responseData: any, statusCode: number }> {
    try {
      const res = await axiosClient.get(`${this.channelPartnerApiUrl}channel-partner/profile`)
        .then((response) => response);
      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response?.data || error.message || 'Network error',
        statusCode: error.response?.status || 500
      });
    }
  }

  async getChannelPartnerById(channelPartnerId: string):
  Promise<{ responseData: ChannelPartner | any, statusCode: number }> {
    try {
      const res = await axiosClient
        .get(`${this.channelPartnerApiUrl}channel-partner/getById/${channelPartnerId}`)
        .then((response) => response);
      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response?.data || error.message || 'Network error',
        statusCode: error.response?.status || 500
      });
    }
  }

  async getChannelPartnerFromCognito(username: string):
  Promise<{ responseData: any, statusCode: number }> {
    try {
      const res = await axiosClient
        .get(`${this.channelPartnerApiUrl}channel-partner/cognito/${username}`)
        .then((response) => response);
      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response?.data || error.message || 'Network error',
        statusCode: error.response?.status || 500
      });
    }
  }

  async updateBasicDetails(basicProfile: BasicProfile, cpId : string):
  Promise<{ responseData: any, statusCode: number }> {
    try {
      const res = await axiosClient
        .patch(`${this.channelPartnerApiUrl}channel-partner/${cpId}/basicDetails`, basicProfile)
        .then((response) => response);

      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response?.data || error.message || 'Network error',
        statusCode: error.response?.status || 500
      });
    }
  }

  async checkCPExistByEmail(primaryEmail: string):
  Promise<{ responseData: any | any, statusCode: number }> {
    try {
      const res = await axiosClient
        .get(`${this.channelPartnerApiUrl}channel-partner/email/${primaryEmail}`)
        .then((response) => response);
      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response?.data || error.message || 'Network error',
        statusCode: error.response?.status || 500
      });
    }
  }

  async updateBankDetails(bankDetails: BankDetails, cpId : string):
  Promise<{ responseData: any, statusCode: number }> {
    try {
      const res = await axiosClient
        .patch(`${this.channelPartnerApiUrl}channel-partner/${cpId}/bankDetails`, bankDetails)
        .then((response) => response);

      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response?.data || error.message || 'Network error',
        statusCode: error.response?.status || 500
      });
    }
  }

  async addService(serviceType: ServiceType, cpId : string):
  Promise<{ responseData: any, statusCode: number }> {
    try {
      const res = await axiosClient
        .patch(`${this.channelPartnerApiUrl}channel-partner/${cpId}/service`, serviceType)
        .then((response) => response);

      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response?.data || error.message || 'Network error',
        statusCode: error.response?.status || 500
      });
    }
  }

  async updateService(serviceType: ServiceType, cpId : string):
  Promise<{ responseData: any, statusCode: number }> {
    try {
      const res = await axiosClient
        .patch(`${this.channelPartnerApiUrl}channel-partner/${cpId}/service/update`, serviceType)
        .then((response) => response);

      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response?.data || error.message || 'Network error',
        statusCode: error.response?.status || 500
      });
    }
  }

  async deleteService(serviceTypeId: string, cpId : string):
  Promise<{ responseData: any, statusCode: number }> {
    try {
      const res = await axiosClient
        .delete(`${this.channelPartnerApiUrl}channel-partner/${cpId}/service/${serviceTypeId}`)
        .then((response) => response);

      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response?.data || error.message || 'Network error',
        statusCode: error.response?.status || 500
      });
    }
  }

  async addPincodeDay(dayAreas: DayAreas, cpId : string):
  Promise<{ responseData: any, statusCode: number }> {
    try {
      const res = await axiosClient
        .patch(`${this.channelPartnerApiUrl}channel-partner/${cpId}/dayAreas`, dayAreas)
        .then((response) => response);

      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response?.data || error.message || 'Network error',
        statusCode: error.response?.status || 500
      });
    }
  }

  async updatePincodeDay(dayAreas: DayAreas, cpId : string):
  Promise<{ responseData: any, statusCode: number }> {
    try {
      const res = await axiosClient
        .patch(`${this.channelPartnerApiUrl}channel-partner/${cpId}/dayAreas/update`, dayAreas)
        .then((response) => response);

      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response?.data || error.message || 'Network error',
        statusCode: error.response?.status || 500
      });
    }
  }

  async deletePincodeDay(day: number, cpId : string):
  Promise<{ responseData: any, statusCode: number }> {
    try {
      const res = await axiosClient
        .delete(`${this.channelPartnerApiUrl}channel-partner/${cpId}/dayAreas/${day}`)
        .then((response) => response);

      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response?.data || error.message || 'Network error',
        statusCode: error.response?.status || 500
      });
    }
  }

  async getChannelPartnerByService(serviceTypeId: string, area : string):
  Promise<{ responseData: any, statusCode: number }> {
    try {
      const res = await axiosClient
        .get(`${this.channelPartnerApiUrl}channel-partner/service/${serviceTypeId}/area/${area}`)
        .then((response) => response);

      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response?.data || error.message || 'Network error',
        statusCode: error.response?.status || 500
      });
    }
  }

  async deleteBrand(brandId: string, cpId : string):
  Promise<{ responseData: any, statusCode: number }> {
    try {
      const res = await axiosClient
        .delete(`${this.channelPartnerApiUrl}channel-partner/${cpId}/brand/${brandId}`)
        .then((response) => response);

      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response?.data || error.message || 'Network error',
        statusCode: error.response?.status || 500
      });
    }
  }

  async addBrand(addBrand: BrandsProducts, cpId : string):
  Promise<{ responseData: any, statusCode: number }> {
    try {
      const res = await axiosClient
        .patch(`${this.channelPartnerApiUrl}channel-partner/${cpId}/brand`, addBrand)
        .then((response) => response);

      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response?.data || error.message || 'Network error',
        statusCode: error.response?.status || 500
      });
    }
  }

  async updateBrand(updateBrand: BrandsProducts, cpId : string):
  Promise<{ responseData: any, statusCode: number }> {
    try {
      const res = await axiosClient
        .patch(`${this.channelPartnerApiUrl}channel-partner/${cpId}/brand/update`, updateBrand)
        .then((response) => response);

      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response?.data || error.message || 'Network error',
        statusCode: error.response?.status || 500
      });
    }
  }

  async addServiceAreas(serviceAreas: string[], cpId : string):
  Promise<{ responseData: any, statusCode: number }> {
    try {
      console.log('API Call - URL:', `${this.channelPartnerApiUrl}channel-partner/${cpId}/serviceAreas`);
      console.log('API Call - Data:', serviceAreas);
      const res = await axiosClient
        .patch(`${this.channelPartnerApiUrl}channel-partner/${cpId}/serviceAreas`, serviceAreas)
        .then((response) => response);

      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response?.data || error.message || 'Network error',
        statusCode: error.response?.status || 500
      });
    }
  }

  async deleteServiceArea(serviceAreaIds: string, cpId: string):
  Promise<{ responseData: any, statusCode: number }> {
    try {
      const res = await axiosClient
        .delete(`${this.channelPartnerApiUrl}channel-partner/${cpId}/serviceAreas/${serviceAreaIds}`)
        .then((response) => response);

      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response?.data || error.message || 'Network error',
        statusCode: error.response?.status || 500
      });
    }
  }

  async addDocument(document: DocumentDetails, cpId : string):
  Promise<{ responseData: any, statusCode: number }> {
    try {
      const res = await axiosClient
        .patch(`${this.channelPartnerApiUrl}channel-partner/${cpId}/document`, document)
        .then((response) => response);

      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response?.data || error.message || 'Network error',
        statusCode: error.response?.status || 500
      });
    }
  }

  async deleteDocument(id: string, cpId: string):
  Promise<{ responseData: any, statusCode: number }> {
    try {
      const res = await axiosClient
        .delete(`${this.channelPartnerApiUrl}channel-partner/${cpId}/document/${id}`)
        .then((response) => response);

      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response?.data || error.message || 'Network error',
        statusCode: error.response?.status || 500
      });
    }
  }

  async addProfilePhoto(document: FileModel, cpId : string):
  Promise<{ responseData: any, statusCode: number }> {
    try {
      const res = await axiosClient
        .patch(`${this.channelPartnerApiUrl}channel-partner/${cpId}/profileImage`, document)
        .then((response) => response);

      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response?.data || error.message || 'Network error',
        statusCode: error.response?.status || 500
      });
    }
  }

  async submitProfile(cpId : string):
  Promise<{ responseData: any, statusCode: number }> {
    try {
      const res = await axiosClient
        .post(`${this.channelPartnerApiUrl}channel-partner/${cpId}/submit`)
        .then((response) => response);

      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response?.data || error.message || 'Network error',
        statusCode: error.response?.status || 500
      });
    }
  }

  async getActivityLogsById(id: string):
  Promise<{ responseData: ActivityLog[] | any, statusCode: number }> {
    try {
      const res = await axiosClient
        .get(`${this.channelPartnerApiUrl}activityLogs/${id}`)
        .then((response) => response);
      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response?.data || error.message || 'Network error',
        statusCode: error.response?.status || 500
      });
    }
  }

  async getActiveChannelPartners():
  Promise<{ responseData: any, statusCode: number }> {
    try {
      const res = await axiosClient.get(`${this.channelPartnerApiUrl}channel-partner/list/active`)
        .then((response) => response);
      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response?.data || error.message || 'Network error',
        statusCode: error.response?.status || 500
      });
    }
  }

  async updateChannelPartnerStatus(attributes: any):
  Promise<{ responseData: any, statusCode: number }> {
    try {
      const body = {
        ...attributes,
      };

      const res = await axiosClient
        .put(`${this.channelPartnerApiUrl}channel-partner/status`, body)
        .then((response) => response);
      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response?.data || error.message || 'Network error',
        statusCode: error.response?.status || 500
      });
    }
  }

  // calls GET api to get channel Partner availability slots present in the database
  async getChannelPartnerAvailabilitySlots(channelPartnerId: string, dates: any):
  Promise<{ responseData: Availability[], statusCode: number }> {
    try {
      const res = await axiosClient.get(`${this.requestManagementUrl}requests/calendar/timeSlots/channelPartner/${channelPartnerId}`, { params: dates }).then((response) => response);
      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.data,
        statusCode: error.status
      });
    }
  }

  async getChannelPartnersByPaginationAndFilters(options: PaginationAndFilter):
  Promise<{ responseData: any, statusCode: number }> {
    try {
      const res = await axiosClient
        .post(`${this.channelPartnerApiUrl}channel-partner/getByPaginationAndFilter`, options)
        .then((response) => response);

      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response?.data || error.message || 'Network error',
        statusCode: error.response?.status || 500
      });
    }
  }
}

export const channelPartnerApi = new ChannelPartnerApi();
